import AboutSection from "../sections/AboutSection";
import BlogPreview from "../sections/BlogPreview";
import HeroSection from "../sections/HeroSection";
import MetricsSection from "../sections/MetricsSection";
import NowBuildingSection from "../sections/NowBuildingSection";
import ProductsPreview from "../sections/ProductsPreview";
import TimelineSection from "../sections/TimelineSection";
import WhatWeBuild from "../sections/WhatWeBuild";

function HomePage({ onNavigate }) {
  return (
    <main>
      <HeroSection onNavigate={onNavigate} />
      <ProductsPreview onNavigate={onNavigate} />
      <WhatWeBuild />
      <MetricsSection />
      <TimelineSection />
      <NowBuildingSection />
      <BlogPreview />
      <AboutSection />
    </main>
  );
}

export default HomePage;
